import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InternetCampaignState } from './internetCampaign.types';

const initialState: InternetCampaignState = {
  internetReferenceCampaign: undefined,
  internetProviderCampaign: undefined,
};

const internetCampaignSlice = createSlice({
  initialState,
  name: 'internetCampaign',
  reducers: {
    setInternetCampaign: (
      state,
      action: PayloadAction<{ internetReferenceCampaign: string; internetProviderCampaign: string }>,
    ) => {
      state.internetReferenceCampaign = action.payload.internetReferenceCampaign;
      state.internetProviderCampaign = action.payload.internetProviderCampaign;
    },
    setInternetReferenceCampaign: (state, action) => {
      state.internetReferenceCampaign = action.payload;
    },
    setInternetProviderCampaign: (state, action) => {
      state.internetProviderCampaign = action.payload;
    },
  },
});

export const { setInternetCampaign, setInternetReferenceCampaign, setInternetProviderCampaign } =
  internetCampaignSlice.actions;

export const internetCampaignReducer = internetCampaignSlice.reducer;
